import type { DataViewMode } from 'components/DataView';
import type { GetSupplyOrdersQuery } from 'data/__generated__';

import { SupplyOrdersDataTableView } from '../SupplyOrdersDataTableView';
import { SupplyOrdersTimelineView } from '../SupplyOrdersTimelineView';
import { SupplyOrdersTrelloView } from '../SupplyOrdersTrelloView';

export type SupplyOrderRow = GetSupplyOrdersQuery['supplyOrders'][number];

// Les trois vues ne se connaissent pas : elles reçoivent les lignes déjà filtrées et l'API de sélection,
// portées par la `DataView`. `render` est un champ de config, comme `ColumnDef.cell`.
export const SUPPLY_ORDER_VIEWS: DataViewMode<SupplyOrderRow>[] = [
    {
        key: 'kanban',
        label: 'Kanban',
        render: ({ rows, selection }) => (
            <SupplyOrdersTrelloView
                supplyOrders={rows}
                selectedSupplyOrderIds={selection.selectedKeys}
                setSelectedSupplyOrderIds={selection.setSelectedKeys}
                toggleSupplyOrderSelection={selection.toggleKey}
            />
        ),
    },
    {
        key: 'timeline',
        label: 'Timeline',
        render: ({ rows, selection }) => (
            <SupplyOrdersTimelineView
                supplyOrders={rows}
                selectedSupplyOrderIds={selection.selectedKeys}
                toggleSupplyOrderSelection={selection.toggleKey}
            />
        ),
    },
    {
        key: 'table',
        label: 'Tableau',
        render: ({ rows, selection }) => (
            <SupplyOrdersDataTableView
                supplyOrders={rows}
                selectedSupplyOrderIds={selection.selectedKeys}
                setSelectedSupplyOrderIds={selection.setSelectedKeys}
            />
        ),
    },
];
